import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import 'moment/locale/ru';

import Breadcrumbs from '../../../common/Breadcrumbs';

import { checkDelivered } from '../../../../helpers';

import { INFO_STATUS_BAR_TRANSLATE } from '../../../../config';
import { badgesStyle } from '../../../../config';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

moment.locale('ru');

const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  .col-8 {
    align-items: center;
    display: flex;

    .page-title-box {
      margin-right: 45px;
    }
  }
  .fe-arrow-left {
    color: #323a46;
    margin-right: 10px;
  }
  .breadcrumb {
    padding-top: 5px;
  }
  .status-badge,
  .payment-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-left: 10px;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    background: #ccc;
    border: 1px solid #fff;
    color: #296775;
    padding: 2px 8px 0;
    min-width: 80px;
    text-align: center;
    height: 19px;
    .status-badge-tip {
      text-align: left;
    }
    i {
      font-size: 12px;
      margin-top: -2px;
    }
  }
  .payment-badge .status-badge-tip {
    left: 0;
    width: 200px;
  }
  .status-badge-wrapper {
    position: relative;
  }
  .status-badge-tip {
    position: absolute;
    z-index: 100;
    background: white;
    padding: 5px 10px;
    border-radius: 3px;
    width: 150px;
    border: 1px solid #ebebeb;
    top: 25px;
    left: 8px;
  }

  .col-3 {
    padding-top: 10px;
    margin-left: auto;
  }

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: flex-start;
    .col-8 {
      max-width: 100%;
    }
    .col-3 {
      margin-left: 0;
    }
    .page-title-box .page-title {
      line-height: 45px;
    }
  }
`;

const DesktopHeader = (props) => {
  const { history, isNew, currentOrder, PaymentBadge } = props;

  const customBackLink = history.location.state && history.location.state.customBackLink;

  const pageTitle = isNew ? 'Новый заказ' : currentOrder ? currentOrder.id : '';
  const breadcrumbs = [
    { title: 'Заказы', route: customBackLink ? customBackLink : '/orders' },
    { title: pageTitle },
  ];

  const [tip, changeTip] = useState(false);

  const { t } = useAutoTranslation();

  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle + ' — Кактус';
    }
  }, [pageTitle]);

  return (
    <Wrapper className="row">
      <div className="col-8">
        <div className="page-title-box">
          <h4 className="page-title">
            <Link to={breadcrumbs[breadcrumbs.length - 2].route}>
              <i className="fe-arrow-left" />
            </Link>
            {pageTitle}
          </h4>
        </div>
        {!isNew ? (
          <Fragment>
            <div>
              <i className="fe-calendar mr-1" />
              {moment(currentOrder.date).format('DD MMM YYYY HH:mm:SS')}
            </div>
            <div className="status-badge-wrapper">
              {currentOrder.status !== 'ORDER_INFO_REQUIRE_PAYMENT' ? (
                <div
                  className="status-badge"
                  style={badgesStyle[currentOrder.status]}
                  onMouseOver={() => changeTip(true)}
                  onMouseOut={() => changeTip(false)}
                >
                  {t(INFO_STATUS_BAR_TRANSLATE[currentOrder.status])}
                  {` `}
                  {currentOrder.delivery?.actualDeliveryDate && checkDelivered(currentOrder.status)
                    ? moment(currentOrder.delivery?.actualDeliveryDate).format(`DD.MM.YYYY`)
                    : null}
                </div>
              ) : null}
              {tip && currentOrder.repeatConfirmationDate && (
                <div className="status-badge-tip">
                  Время звонка: <br />{' '}
                  <strong>
                    {moment(currentOrder.repeatConfirmationDate).format('DD-MM-YYYY HH:mm:ss')}
                  </strong>
                </div>
              )}
            </div>
            <PaymentBadge {...currentOrder} noSubtitle={true} />
          </Fragment>
        ) : null}
      </div>
      <div className="col-3">
        <Breadcrumbs data={breadcrumbs} floatRight />
      </div>
    </Wrapper>
  );
};

export default DesktopHeader;
